import { BellIcon } from 'lucide-react';
import React from 'react';

const BellNewIcon = () => {
    return (
        <span className="flex items-center gap-1 bg-orange-500 text-white text-xs font-bold animate-pulse rounded-full px-2 py-0.5">
            <BellIcon size={12} />
            <span className="ml-1 rounded-full">NEW</span>
        </span>
    );
};

export default BellNewIcon;